import { createSlice } from '@reduxjs/toolkit';
import { AxiosResponseModel } from '../../@types/base';
import { CONSTS } from './const';
import { dispatch } from '../store';
import axios from '../../utils/axios';
import { HttpStatusCodes } from '../../constants/http-status-codes.enum';
import {
  AddZoneModel,
  ZoneDetailModel,
  ZoneResultModel,
  GetZoneShiftWithReturnResponse,
  SetZoneShiftModel,
  UpdateZoneModel
} from '../../@types/zone';

type ZoneState = {
  zoneError: boolean;
  isZoneLoading: boolean;
  zoneList: ZoneDetailModel[];
  zoneDetail: ZoneDetailModel | null;
};

const zoneDetailInit: ZoneDetailModel = {
  id: 0,
  name: '',
  description: '',
  companyId: 0,
  createdAt: '',
  updatedAt: '',
  zoneImage: ''
};

const initialState: ZoneState = {
  zoneError: false,
  isZoneLoading: false,
  zoneList: [],
  zoneDetail: null
};

const slice = createSlice({
  name: 'zone',
  initialState,
  reducers: {
    // ----------------------------------------------------------------------
    // ZONE
    // ----------------------------------------------------------------------

    // START ZONE LOADING
    startZoneLoading(state) {
      state.isZoneLoading = true;
    },

    stopZoneLoading(state) {
      state.isZoneLoading = false;
    },

    // HAS ERROR ZONE
    hasErrorZone(state, action) {
      state.isZoneLoading = false;
      state.zoneError = action.payload;
    },

    // GET ALL ZONES
    getAllZonesSuccess(state, action) {
      state.isZoneLoading = false;
      state.zoneList = action.payload;
    },

    // GET ZONE DETAIL
    getZoneByIdSuccess(state, action) {
      state.isZoneLoading = false;
      state.zoneDetail = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {} = slice.actions;

// ----------------------------------------------------------------------
// ZONE

export async function getAllZonesWithReturn() {
  dispatch(slice.actions.startZoneLoading());
  try {
    const url = CONSTS.ZONE_GET_GET_ALL_ZONES;
    const response: AxiosResponseModel<ZoneResultModel> = await axios
      .get(url)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(slice.actions.getAllZonesSuccess(response.data?.data));
    } else {
      dispatch(slice.actions.getAllZonesSuccess([]));
    }
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorZone(error));
    return error.response.data;
  }
}

export function getZoneById(zoneId: number) {
  return async () => {
    dispatch(slice.actions.startZoneLoading());
    try {
      const response: AxiosResponseModel<ZoneDetailModel> = await axios
        .get(`${CONSTS.ZONE_GET_GET_ZONE}/${zoneId}`)
        .catch((error) => {
          if (error.response) {
            return error.response.data;
          }
          return error;
        });
      if (response && response.status === HttpStatusCodes.StatusSuccess) {
        dispatch(
          slice.actions.getZoneByIdSuccess(
            response.data?.data || zoneDetailInit
          )
        );
      } else {
        dispatch(slice.actions.getZoneByIdSuccess(zoneDetailInit));
      }
    } catch (error: any) {
      dispatch(slice.actions.hasErrorZone(error));
    }
  };
}

export async function addZoneWithReturn(
  zone: AddZoneModel
) {
  dispatch(slice.actions.startZoneLoading());
  try {

    // zone.image = fileUrl;
    const response: AxiosResponseModel<ZoneResultModel> = await axios
      .post(CONSTS.ZONE_POST_ADD_ZONE, zone)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      // await getAllZonesWithReturn();
      dispatch(slice.actions.hasErrorZone(false));
    } else {
      dispatch(slice.actions.hasErrorZone(response.data?.message || ''));
    }
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorZone(error));
    return error.response.data;
  }
}

export async function updateZoneWithReturn(
  data: UpdateZoneModel,
  id: number
) {
  try {
    const response: AxiosResponseModel<null> = await axios
      .post(`${CONSTS.ZONE_POST_UPDATE_ZONE}/${id}`, data)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      // await getAllZonesWithReturn();
      dispatch(slice.actions.hasErrorZone(false));
    } else {
      dispatch(slice.actions.hasErrorZone(response.data?.message || ''));
    }
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorZone(error));
    return error.response.data;
  }
}

export async function deleteZone(zoneId: number) {
  dispatch(slice.actions.startZoneLoading());
  try {
    const response: AxiosResponseModel<null> = await axios
      .delete(`${CONSTS.ZONE_DELETE_DELETE_ZONE}/${zoneId}`)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    dispatch(slice.actions.stopZoneLoading());
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorZone(error));
    return error.response.data;
  }
}

export async function getZoneShiftWithReturn(id: number){
  try {
    const response: AxiosResponseModel<GetZoneShiftWithReturnResponse> = await axios
      .get(`${CONSTS.ZONE_GET_GET_ZONE_SHIFT}/${id}`)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    dispatch(slice.actions.stopZoneLoading());
    return response.data;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorZone(error));
    return error.response.data;
  }
}

export async function setZoneShiftWithReturn(id: number, data: SetZoneShiftModel){
  try {
    const response: AxiosResponseModel<null> = await axios
      .post(`${CONSTS.ZONE_POST_SET_ZONE_SHIFT}/${id}`, data)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    dispatch(slice.actions.stopZoneLoading());
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorZone(error));
    return error.response.data;
  }
}